import { Link } from 'react-router-dom'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

export const NotFound = () => (
  <div className={'ctpf-not-found'}>
    <div className={'ctp-not-found__inner'}>
      <Link to="/">
        <img src="/images/logo/elevateos-logo-wide-white.svg" alt={ELEVATEOS_LOGO_ALT} />
      </Link>
      <h1>
        We couldn't find the page
        <br />
        you're looking for.
      </h1>
      <Link className={'button'} to="/">
        Go to App
      </Link>
    </div>
  </div>
)
